import { useEffect } from 'react';

const addEventCalendar = () => {
  // Do we have any AddEvent elements?
  const addEventElements = document.querySelector('[data-replace-add-event-calendar]');
  // Do we have the AddEvent javascript loaded?
  const addEventScript = document.querySelector('.ae-emd-script');
  
  // We have add event elements and no add event script loaded
  if (addEventElements && !addEventScript) {
    // Load the add-event script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = false;
    script.src = 'https://www.addevent.com/js/cal.embed.t1.init.js';
    script.className = 'ae-emd-script';
    document.getElementsByTagName('body')[0].appendChild(script);

  }
  return () => {
    document.querySelector('.ae-emd-script')?.remove();
  };
};

const addEventShare = () => {
  // Do we have any AddEvent elements?
  const addEventElements = document.querySelector('[data-replace-add-event-share]');
  // Do we have the AddEvent javascript loaded?
  const addEventScript = document.querySelector('.ae-share-script');
  
  // We have add event elements and no add event script loaded
  if (addEventElements && !addEventScript) {
    // Load the add-event script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = false;
    script.src = 'https://cdn.addevent.com/libs/stc/1.0.2/stc.min.js';
    script.className = 'ae-share-script';
    document.getElementsByTagName('body')[0].appendChild(script);
    
    const styles = document.createElement('link');
    styles.rel = 'stylesheet';
    styles.href = 'https://cdn.addevent.com/libs/stc/themes/fff-theme-12/theme.css';
    styles.type = 'text/css';
    styles.media = 'all';
    styles.className = 'ae-share-styles';
    document.getElementsByTagName('body')[0].appendChild(styles);
  }
  return () => {
    document.querySelector('.ae-share-script')?.remove();
    document.querySelector('.ae-share-styles')?.remove();
  };
};

const useAddEvent = () => {
  useEffect(() => {
    const addEventCalendarCleanup = addEventCalendar();
    const addEventShareCleanup = addEventShare();

    return () => {
      addEventCalendarCleanup();
      addEventShareCleanup();
    };
  }, []);
};

export default useAddEvent;
